import {useContext} from 'react';

import ReportSummaryContext from '../../contexts/ReportSummaryContext';

const useReportSummary = () => {
  return useContext(ReportSummaryContext);
};

export default useReportSummary;
